<template>
  <el-dialog
    top="80px"
    width="680px"
    class="create-artifact-popup"
    :title="`${!artifact ? 'Tạo mới ' : 'Cập nhật thông tin'}`"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      class="pt-2 pr-2"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item v-if="!type && !artifact" label="Loại điểm đến" prop="type">
        <el-select
          v-model="form.type"
          filterable
          class="w-100"
          @change="handleChangePlaceType"
        >
          <el-option v-for="t in placeTypes" :key="t.value" :label="t.name" :value="t.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!type && !artifact" label="Điểm đến" prop="place_id">
        <el-select
          v-model="form.place_id"
          class="w-100"
          filterable
          remote
          placeholder="Chọn điểm đến"
          :remote-method="searchPlace"
          :loading="searching"
        >
          <el-option v-for="p in places" :key="p.id" :label="p.name" :value="p.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Tên" prop="name">
        <el-input
          v-model="form.name"
          :disabled="callingAPI"
          placeholder="Nhập vào tên"
        ></el-input>
      </el-form-item>
      <el-form-item label="STT hiển thị" prop="ordered">
        <el-input
          v-model="form.ordered"
          :disabled="callingAPI"
          type="number"
          placeholder="Nhập stt hiển thị mong muốn"
        ></el-input>
      </el-form-item>
      <el-form-item label="Link Vrtour" prop="vrtour">
        <el-input
          v-model="form.vrtour"
          :disabled="callingAPI"
          placeholder="Nhập vào link"
        ></el-input>
      </el-form-item>
      <el-form-item label="Mô tả" prop="description">
        <el-input
          v-model="form.description"
          :rows="3"
          :disabled="callingAPI"
          type="textarea"
          placeholder="Nhập mô tả"
        ></el-input>
      </el-form-item>
      <el-form-item label="Thông tin nội dung" prop="content">
        <editor
          v-if="visible"
          editor-key="content"
          :value="form.content"
          @change="(v) => (form.content = v)"
        />
      </el-form-item>
      <el-form-item v-if="artifactInfo && visible" lang>
        <audios :data.sync="artifactInfo" type="artifact" />
        <pictures :data.sync="artifactInfo" type="artifact" />
        <videos :data.sync="artifactInfo" type="artifact" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Hủy</el-button>
      <el-button
        v-if="!artifactInfo"
        type="primary"
        :loading="callingAPI"
        @click="handleCreateArtifact"
      >Tạo mới</el-button>
      <el-button
        v-else
        type="primary"
        :loading="callingAPI"
        @click="handleUpdateArtifact"
      >Cập nhật</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters, mapActions } from 'vuex'
import Audios from '../cards/Audios.vue'
import Pictures from '../cards/Pictures.vue'
import Videos from '../cards/Videos.vue'
import Editor from '../items/Editor.vue'

import { createArtifact, updateArtifact } from '@/services/artifact'
import { getPlaceTypes } from '@/utils/filters'
import { listPlaces } from '@/services/place'

export default {
  name: 'CreateArtifact',
  components: {
    Audios,
    Pictures,
    Editor,
    Videos
  },
  props: {
    visible: Boolean,
    artifact: Object,
    object: Object,
    type: String
  },
  data() {
    return {
      callingAPI: false,
      places: [],
      searchText: '',
      form: {
        type: this.type || '',
        place_id: this.object ? this.object.id : '',
        name: '',
        ordered: '',
        vrtour: '',
        description: '',
        content: ''
      },
      artifactInfo: null,
      searching: false,
      rules: {
        type: [
          { required: true, message: 'Loại điểm đến không được để trống', trigger: ['blur', 'change'] }
        ],
        place_id: [
          { required: true, message: 'Điểm đến không được để trống', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: 'Tên không được để trống', trigger: ['blur', 'change'] }
        ],
        ordered: [
          { required: true, message: 'STT không được để trống', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language']),
    placeTypes() {
      return getPlaceTypes(false).filter((p) => p.type === 'place')
    },
    params() {
      return {
        locale: this.language,
        place_types: this.form.type,
        per_page: 10,
        search_text: this.searchText
      }
    },
    payload() {
      let p = this.artifactInfo ? { ...this.artifactInfo } : { attraction_id: null }
      p = {
        ...p,
        ...this.form,
        locale: this.language
      }
      if (this.object && this.object.id) {
        return {
          ...p,
          place_id: this.object.id
        }
      }
      return p
    }
  },
  beforeMount() {
    if (!this.type) {
      this.form.type = this.placeTypes[0].value
      this.getPlaces()
    }
    this.loadData()
  },
  methods: {
    ...mapActions('artifact', ['updateReloadArtifactGroup']),
    loadData() {
      if (this.visible && this.artifact) {
        this.artifactInfo = this.artifact
        this.form = {
          name: this.artifact.name,
          ordered: this.artifact.ordered,
          vrtour: this.artifact.vrtour,
          description: this.artifact.description,
          content: this.artifact.content
        }
      } else {
        this.form = {
          type: this.type || this.placeTypes[0].value,
          place_id: '',
          name: '',
          ordered: '',
          vrtour: '',
          description: '',
          content: ''
        }
        this.artifactInfo = null
      }
    },
    handleCreateArtifact() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          createArtifact(this.payload).then((response) => {
            this.callingAPI = false
            this.artifactInfo = response
            this.$notify.success({
              title: 'Thông báo',
              message: 'Tạo mới thành công'
            })
            this.$emit('reload')
          }).catch((error) => {
            this.callingAPI = false
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
        }
      })
    },
    handleUpdateArtifact() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          updateArtifact(this.payload).then(() => {
            this.callingAPI = false
            this.handleClose()
            this.$notify.success({
              title: 'Thông báo',
              message: 'Cập nhật thành công'
            })
            this.$emit('reload')
            this.updateReloadArtifactGroup(dayjs().unix())
          }).catch((error) => {
            this.callingAPI = false
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
        }
      })
    },
    getPlaces() {
      this.searching = true
      const request = listPlaces(this.params)
      request.then((res) => {
        this.places = res.result
        this.searching = false
      }).catch(() => {
        this.places = []
        this.searching = false
      })
    },
    handleChangePlaceType() {
      this.form.place_id = ''
      this.searchText = ''
      this.getPlaces()
    },

    searchPlace(text) {
      this.searchText = text
      setTimeout(() => {
        this.getPlaces()
      }, 100)
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.create-artifact-popup {
  .el-dialog__body {
    max-height: 550px;
    overflow: auto;
  }
}
</style>
